/* unplugin-vue-components disabled */import script from "./ForgetPasswordStep2Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPasswordStep2Popup.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPasswordStep2Popup.vue?vue&type=style&index=0&id=b3b0eb0e&lang=scss"

const __exports__ = script;

export default __exports__